import type { JSX } from "react";

import { GuideNav } from "../../GuideNav";
import type { SectionRenderInput } from "./types";

/**
 * 3. Contents — the strip over the numbered sections below it.
 *
 * Derived, and the only section that is: its entries are the sections the
 * document draws, already anchored and numbered by the body that resolved them,
 * so the strip and the eyebrows can never disagree about how many sections there
 * are or what they are called.
 */
export function ContentsSection({ nav }: SectionRenderInput): JSX.Element | null {
  return <GuideNav sections={nav} />;
}
